<script>
  import { style, blocklist, text, richtext, image, url } from "../toolbox.js";
  import { link } from "svelte-routing";

  export let block;
</script>

<!-- -------- START HEADER 10 w/ carousel ------- -->
<section style="{style(block)}">
  <div class="container">
  <div id="carouselExampleControls" class="carousel slide" data-bs-ride="carousel">
    <div class="carousel-inner">
      {#each blocklist(block, "slides") as item}
      <div class="carousel-item active">
        <div class="page-header min-vh-75 border-radius-xl" style="background-image: url({image(item, 'background', [1000, '_'])});">
          <span class="mask bg-gradient-dark"></span>
          <div class="container">
            <div class="row">
              <div class="col-lg-6 my-auto">
                <div class="p-5">
                  <h4 class="text-white mb-0 fadeIn1 fadeInBottom">{text(item, 'headingFirst')}</h4>
                  <h1 class="text-white fadeIn2 fadeInBottom">{text(item, 'heading')}</h1>
                  <p class="h4 text-white opacity-8 fadeIn3 fadeInBottom">{@html richtext(item, 'body')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/each}
    </div>
    <div class="min-vh-75 position-absolute w-100 top-0">
      <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-bs-slide="prev">
        <span class="carousel-control-prev-icon position-absolute bottom-50 ms-n7" aria-hidden="true"></span>
        <span class="visually-hidden">Previous</span>
      </a>
      <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-bs-slide="next">
        <span class="carousel-control-next-icon position-absolute bottom-50 me-n7" aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
      </a>
    </div>
  </div>
  </div>
</section>
<!-- -------- END HEADER 11 w/ carousel ------- -->
